import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { Plus } from '@phosphor-icons/react';
import { Button, Modal } from 'app/components';
import { DraggableList, Question, QuestionBuilder } from '../../../event-create/containers/step-3/components';
import { ACTION_ITEMS } from '../../../event-create/containers/step-3/constants';
import { generateUniqueId } from '../../../event-create/containers/step-3/utils';

const BookingDetails = ({ stateName, onChange, isAdmin, readOnly }) => {
  const { eventDetails: eventData } = useSelector((state) => state[stateName || 'eventDashboard']);

  const [isQuestionModalOpen, setIsQuestionModalOpen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState(null);
  const [showDeleteConfirmationModal, setShowDeleteConfirmationModal] = useState({ isOpen: false });

  const isEditable = () => {
    return true;
  };

  const onCloseQuestionModal = () => {
    if (selectedQuestion) setSelectedQuestion(null);
    setIsQuestionModalOpen(false);
  }

  const onAddQuestion = (questionConfig) => {
    // add to questions list
    const index = (eventData?.get_to_know_details || [])?.findIndex((item) => item?.id === questionConfig?.id);
    let updatedQuestions = [...(eventData?.get_to_know_details || [])];

    if (index > -1) {
      updatedQuestions[index] = questionConfig;
    } else updatedQuestions = updatedQuestions.concat({ ...questionConfig, id: generateUniqueId() });

    onChangeQuestions(updatedQuestions, 'Added', () => onCloseQuestionModal());
  };

  const onCtaClick = (ctaType, id) => {
    if (ctaType === 'edit') {
      setSelectedQuestion(eventData?.get_to_know_details?.find((item) => item?.label === id));
      setIsQuestionModalOpen(true);
    } else if (ctaType === 'delete') {
      setShowDeleteConfirmationModal({
        id,
        isOpen: true,
      });
    }
  };

  const onMarkRequired = (id) => {
    const updatedQuestions = eventData?.get_to_know_details?.map((item) => {
      if (item?.id === id) return { ...item, isRequired: !item?.isRequired };
      return item;
    });
    onChangeQuestions(updatedQuestions);
  };

  const deleteSelectedQuestion = () => {
    const updatedQuestions = [...(eventData?.get_to_know_details || [])];
    const index = updatedQuestions?.findIndex((item) => item?.label === showDeleteConfirmationModal?.id);
    updatedQuestions.splice(index, 1);
    onChangeQuestions(updatedQuestions, 'Deleted Successfully!', () => setShowDeleteConfirmationModal({ isOpen: false }));
  };

  const onChangeQuestions = (questions, msg, callback) => {
    onChange({
      ...eventData,
      get_to_know_details: questions,
    }, msg || 'Saved', callback);
  };

  const ticketsConfig = useMemo(() => {
    return eventData?.smp_detail_entity_set?.map((ticket) => ({ id: ticket.id, title: ticket.option_value_1 }));
  }, [eventData?.smp_detail_entity_set]);

  return (
    <div className='pt-[36px] px-[80px] flex-1'>
      <div className="step-3-container flex flex-col flex-1 overflow-auto">
        <div className='flex justify-between'>
          <h1 className='heading-24 flex items-center self-stretch'>Get to know your audience</h1>
          {isEditable() && (<Button
            type="tertiary"
            rounded={true}
            iconLeft={<Plus />}
            onClick={() => setIsQuestionModalOpen(true)}
          >
            Add question
          </Button>)}
        </div>
        <div className='form-container-wrapper flex flex-col items-center flex-1 gap-6 mt-9 pr-4'>
          <div className="form-content w-full">
            <DraggableList
              list={eventData?.get_to_know_details || []}
              Component={Question}
              componentProps={{
                ctaList: isEditable() ? ACTION_ITEMS : [],
                showRequiredToggle: true,
                onCtaClick,
                onToggle: onMarkRequired,
                requiredToggleProps: {
                  disabled: !isEditable()
                },
              }}
              onChange={onChangeQuestions}
            />
          </div>
        </div>
        <QuestionBuilder
          onCloseModal={onCloseQuestionModal}
          isOpen={isQuestionModalOpen}
          onAddQuestion={onAddQuestion}
          selectedQuestion={selectedQuestion}
          ticketsConfig={ticketsConfig}
          list={eventData?.get_to_know_details || []}
        />
        <Modal
          className="delete-confirmation-modal"
          primaryText="Delete"
          size="regular"
          isOpen={showDeleteConfirmationModal?.isOpen}
          onClickPrimaryCta={deleteSelectedQuestion}
          onClickSecondaryCta={() => setShowDeleteConfirmationModal({ isOpen: false })}
          title="Are you sure you want to delete this question?"
        />
      </div>
    </div>
  )
}

export default BookingDetails;
